// Enum for table columns (API response fields)
export enum FinishedGoodsTableColumn {
  FINISHED_GOODS_ID = "finished_goods_id",
  NAME = "name__name",
  CATEGORY = "category__name",
  BRAND = "brand__name",
  MODEL = "model__name",
  SPECIFICATION_NAME = "specification_name",
  GRADE = "grade__name",
  COLOR = "color__name",
  STOCK_QUANTITY = "stock_quantity",
  SAFETY_STOCK = "safety_stock",
  DEMAND_FORCAST = "demand_forcast",
  LEAD_TIME = "lead_time",
  STOCK_REQUIRED = "stock_required",
  MODIFIED_DATE = "modified_date",
  DEAD_STOCK = "dead_stock",
  RESERVED = "reserved",
  STATUS = "status",
}

// Enum for export columns (backend expected fields)
export enum FinishedGoodsExportColumn {
  FINISHED_GOODS_ID = "finished_goods_id",
  NAME = "name__name",
  CATEGORY = "category__name",
  BRAND = "brand__name",
  MODEL = "model__name",
  SPECIFICATION_NAME = "specification_name",
  GRADE = "grade__name",
  COLOR = "color__name",
  STOCK_QUANTITY = "stock_quantity",
  SAFETY_STOCK = "safety_stock",
  DEMAND_FORCAST = "demand_forcast",
  LEAD_TIME = "lead_time",
  STOCK_REQUIRED = "stock_required",
  MODIFIED_DATE = "modified_date",
  DEAD_STOCK = "dead_stock",
  RESERVED = "reserved",
  STATUS = "status",
}

// Column display names mapping (for UI)
export const FinishedGoodsColumnLabels: Record<
  FinishedGoodsTableColumn,
  string
> = {
  [FinishedGoodsTableColumn.FINISHED_GOODS_ID]: "Product Id",
  [FinishedGoodsTableColumn.NAME]: "Item Name",
  [FinishedGoodsTableColumn.CATEGORY]: "Category",
  [FinishedGoodsTableColumn.BRAND]: "Brand",
  [FinishedGoodsTableColumn.MODEL]: "Model",
  [FinishedGoodsTableColumn.SPECIFICATION_NAME]: "Specification",
  [FinishedGoodsTableColumn.GRADE]: "Grade",
  [FinishedGoodsTableColumn.COLOR]: "Color",
  [FinishedGoodsTableColumn.STOCK_QUANTITY]: "Stock Qty",
  [FinishedGoodsTableColumn.SAFETY_STOCK]: "Safety Stock",
  [FinishedGoodsTableColumn.DEMAND_FORCAST]: "Demand Forecast",
  [FinishedGoodsTableColumn.LEAD_TIME]: "Lead Time",
  [FinishedGoodsTableColumn.STOCK_REQUIRED]: "Stock Required",
  [FinishedGoodsTableColumn.MODIFIED_DATE]: "Stock Updated On",
  [FinishedGoodsTableColumn.DEAD_STOCK]: "Dead Stock",
  [FinishedGoodsTableColumn.RESERVED]: "Reserved",
  [FinishedGoodsTableColumn.STATUS]: "Status",
};

// Default selected columns for export (all true)
export const getDefaultFinishedGoodsSelectedColumns = () => ({
  [FinishedGoodsExportColumn.FINISHED_GOODS_ID]: true,
  [FinishedGoodsExportColumn.NAME]: true,
  [FinishedGoodsExportColumn.CATEGORY]: true,
  [FinishedGoodsExportColumn.BRAND]: true,
  [FinishedGoodsExportColumn.MODEL]: true,
  [FinishedGoodsExportColumn.SPECIFICATION_NAME]: true,
  [FinishedGoodsExportColumn.GRADE]: true,
  [FinishedGoodsExportColumn.COLOR]: true,
  [FinishedGoodsExportColumn.STOCK_QUANTITY]: true,
  [FinishedGoodsExportColumn.SAFETY_STOCK]: true,
  [FinishedGoodsExportColumn.DEMAND_FORCAST]: true,
  [FinishedGoodsExportColumn.LEAD_TIME]: true,
  [FinishedGoodsExportColumn.STOCK_REQUIRED]: true,
  [FinishedGoodsExportColumn.MODIFIED_DATE]: true,
  [FinishedGoodsExportColumn.DEAD_STOCK]: true,
  [FinishedGoodsExportColumn.RESERVED]: true,
  [FinishedGoodsExportColumn.STATUS]: true,
});

// Status filter options (hardcoded as per backend requirement)
export const statusFilterOptions = [
  { label: "Active", value: "True" },
  { label: "Inactive", value: "False" },
];
